export default __webpack_public_path__ + "static/media/your_order_driver.7da45475.png";